import { render, staticRenderFns } from "./cardListCenter.vue?vue&type=template&id=73074915&scoped=true&"
import script from "./cardListCenter.vue?vue&type=script&lang=js&"
export * from "./cardListCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73074915",
  null
  
)

export default component.exports